(function () {
  function inyectar() {
    if (document.getElementById('mpago-estilos')) return;
    var css = [
      '@media (min-width: 990px){',
      '.product-metodos-pago .product-metodos-pago__imagen{',
      'max-width:var(--mpago-ancho-desktop,340px) !important;}',
      '}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'mpago-estilos';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  }
  function init() {
    if (document.querySelector('[data-mpago]')) inyectar();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
